import style from './nav.module.css';
import ActiveNavLinkButton from './ActiveNavLinkButton';

const Nav = () => {
    return (
        <nav className={style.header}>
            <ul className={style.navLink}>
                <li>
                    <ActiveNavLinkButton to="/dashboard/brand-manager-portal/review-summary">Review Summary</ActiveNavLinkButton>
                </li>
                {/* <li>
                    <ActiveNavLinkButton to="/dashboard/brand-manager-portal/pdp-faq">PDP FAQ</ActiveNavLinkButton>
                </li>
                <li>
                    <ActiveNavLinkButton to="/dashboard/brand-manager-portal/site-faq">Site FAQ</ActiveNavLinkButton>
                </li> */}
            </ul>
        </nav>
    )
}

export default Nav;